export default __webpack_public_path__ + "static/media/klient-mob.e884c9c9.jpg";